export default "__VITE_ASSET__Dq$TOFNK__"